module.exports = __webpack_public_path__ + "img/factory-icon-2.d477a573.svg";